import { IconProps } from "./types";
import React from "react";

export const RepeatIcon = ({
  className,
  fill = "currentColor",
  width = 14,
  height = 14,
  style = {},
}: IconProps): React.ReactElement => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 14 14"
    className={className}
    style={style}
    fill="none"
  >
    <path
      d="M8.75006 3.28125L10.0626 4.59375L8.75006 5.90625"
      stroke={fill}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M9.62503 4.59326H1.75003V7.21826M5.25003 10.7183L3.93753 9.40576L5.25003 8.09326"
      stroke={fill}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M4.37506 9.40576H12.2501V6.78076"
      stroke={fill}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);
